import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ExaminationVariantService } from '../../../../../shared/src/lib/service/examination-variant.service';
import { HttpParams } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { ExaminationVariants } from '../../../../../shared/src/lib/model/examinationVariants.model';
import { AuthenticationService } from '../../../../../shared/src/lib/service/authentification.service';
import { ExaminationService } from '../../../../../shared/src/lib/service/examination.service';


@Component({
  selector: 'app-teacher-variant-list',
  templateUrl: './teacher-variant-list.component.html',
  styleUrls: ['./teacher-variant-list.component.scss']
})
export class TeacherVariantListComponent implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  variantsDataSource: MatTableDataSource<ExaminationVariants> = new MatTableDataSource();
  variantsTableColumns: string[] = ['id', 'title', 'status', 'count_slides', 'actions'];

  examinationStatus: {
    label: string;
    code: string;
    valid: boolean;
  }[];

  myUser;

  constructor(
    private examinationVariantService: ExaminationVariantService,
    private authenticationService: AuthenticationService,
    private examinationService: ExaminationService
  ) { }

  ngOnInit() {
    this.examinationStatus = this.examinationVariantService.getExaminationVariantStatus();

    this.authenticationService.currentUserSubject.subscribe(
      user => {
        if (user && user.hasOwnProperty('user')) {
          this.myUser = user;
          this.getVariants();
        }
      }
    )
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  getVariants(): void {
    let params = new HttpParams();
    params = params.append('status', 'published')
    params = params.append('examination__language__id', this.myUser.teach_language.id)
    params.keys()
    this.examinationVariantService.getExaminationsVariantes(params).subscribe(
      variants => {
        this.variantsDataSource = new MatTableDataSource(variants.results)
      }
    )
  }
  
  joinPreview(variant: ExaminationVariants) {
    this.examinationService.openExamPreview(this.authenticationService.currentUserSubject.value.user.email, variant.id, localStorage.getItem('access_token'));
    if (!variant.is_viewed) {
      this.examinationVariantService.postMarkExaminationVarianteAsView(variant.id).subscribe(
        () => {
          this.authenticationService.reloadUser();
        }
      )
    }
  }

  getStatusLabel = (status) => { return this.examinationStatus.find(element => element.code === status).label }

}
